import { TabStyles } from '@tableau/widgets';
import { HeaderColumn } from '@tableau/widgets-datagrid';
import * as React from 'react';
import { SvgCertifiedIconColumnHeader } from '../../../../gen-src/icons/CertifiedIconColumnHeader';
import { DataStatusHeaderIcon } from '../../dataQualityWarnings/DataQualityDetail';
import { divWithStyle } from '../../style/LayoutComponents';
import { cssClass } from '../../style/StyleFunctions';

// styles from vizportalclient, src/app/spaces/Explorer/ExplorerStyles.ts
const IconHeader = divWithStyle('IconCell', {
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: TabStyles.Spacing.ExtraLargeSpace,
  paddingLeft: TabStyles.Spacing.MediumSpace,
  paddingRight: TabStyles.Spacing.MediumSpace,
});

export const DataQualityHeaderIconClass = cssClass('DataQualityHeaderIconClass', {
  alignContent: 'center',
  display: 'flex',
  justifyContent: 'center'
});

// TODO: make this generic to use props.
function IconHeaderFormatter() {
  return (
    <IconHeader>
      <DataStatusHeaderIcon className={DataQualityHeaderIconClass} />
    </IconHeader>
  );
}

function CertificationIconHeaderFormatter() {
  return (
    <IconHeader>
      <SvgCertifiedIconColumnHeader />
    </IconHeader>
  );
}

export const DataQualityIconHeaderFormatterFactory = React.createFactory<HeaderColumn.HeaderFormatterProps>(IconHeaderFormatter);

export const DataQualityIconHeaderCertificationFormatterFactory = React.createFactory<HeaderColumn.HeaderFormatterProps>(CertificationIconHeaderFormatter);
